import React, { useState, useRef, useEffect } from "react";
import styles from "./choice_firm.module.css";

const ChoiceFirm = ({
  firms, currFirm=null, setFirm, showFirmsList, setShowFirmsList,
  setFormValid=() => {}
}) => {

  const inputRef = useRef(null);
  const [filteredFirms, setFilteredFirms] = useState(firms);

  useEffect(() => {
    if (!currFirm) {
      inputRef.current.value = 'частное лицо';
    } else {
      inputRef.current.value = `${currFirm.name}${currFirm.inn ? `, ИНН ${currFirm.inn}` : ''}`;
    }
  }, [currFirm]);


  const noFirm = {
    id: null,
    name: 'частное лицо',
    inn: null
  }

  const handleClick = (firm) => {
    setFirm(firm.id);
    setShowFirmsList(false);
    setFormValid(true);
    inputRef.current.value = `${firm.name}${firm.inn ? `, ИНН ${firm.inn}` : ''}`;
  }

  const clickInputFirm = () => {
    if (firms.length >= 0) {
      setShowFirmsList(!showFirmsList);
    }
  }

  const changeFirmName = (e) => {
    setShowFirmsList(true);
    if (e.target.value !== '') {
      setFilteredFirms(firms.filter(firm => {
        return firm.name.toLowerCase().includes(e.target.value.toLowerCase());
      }))
    } else {
      setFilteredFirms(firms);
    }
  }

  return (
    <div className={styles.container}>
      <input
        type="text"
        id="firm" name="firm"
        required={true}
        onChange={changeFirmName}
        className="input"
        ref={inputRef}
        onClick={clickInputFirm}
        placeholder="Поиск по названию"
      />
      {showFirmsList && filteredFirms.length >= 0 &&
        <ul className={styles.list} id="list_firms">
          <li className={styles.item} key={-1} onClick={() => handleClick(noFirm)}>
            частное лицо
          </li>
          {filteredFirms.map(firm => {
            return (
              <li className={styles.item} key={firm.id} onClick={() => handleClick(firm)}>
                {firm.name} {firm.inn}
              </li>
            );
          })}
        </ul>
      }
    </div>
  )
};

export default ChoiceFirm;
